/* eslint-disable */
import { CommonGet } from '../../../helpers/HttpClient';


export default {
    GetAllProductsForDropDown,
    GetOutletDetailsByproductIdAndDate,
};

async function GetAllProductsForDropDown() {
    const response = await CommonGet('/api/ViewOutletOrdersProductwise/GetAllProductsDetails', null);
    return response.data;
}

async function GetOutletDetailsByproductIdAndDate(productID, orderDate) {
    const response = await CommonGet('/api/ViewOutletOrdersProductwise/GetOutletDetailsByproductIdAndDate',
        'productID=' + parseInt(productID) + '&orderDate=' + orderDate);
    return response.data;
}






